import { render } from "./UnitsNumberInput.vue?vue&type=template&id=ca0b6d76&ts=true"
import script from "./UnitsNumberInput.vue?vue&type=script&lang=ts"
export * from "./UnitsNumberInput.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__